import React from 'react';
import { SmallBody } from '@indigo-ag/component-module';
import { DeforestationMonitoringDataList } from './DeforestationMonitoringDataList';
import { MonitoringData } from '@indigo-ag/schema';
import i18next from 'i18next';
import styled from 'styled-components';

interface DeforestationMonitoringWrapperProps {
  prodes?: MonitoringData[];
  deter?: MonitoringData[];
}

const ListGridContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  max-height: 480px;
  overflow-y: auto;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
`;

export const DeforestationMonitoringWrapper: React.FC<DeforestationMonitoringWrapperProps> = ({ prodes, deter }) => {
  const hasProdes = prodes && prodes.length > 0;
  const hasDeter = deter && deter.length > 0;

  if (!hasProdes && !hasDeter) {
    return <SmallBody>{i18next.t('deforestationMonitoringData-empty')}</SmallBody>;
  }

  return (
    <ListGridContainer>
      <DeforestationMonitoringDataList
        title={i18next.t('deforestationMonitoringData-prodes')}
        monitoringDataList={prodes || []}
      />
      <DeforestationMonitoringDataList
        title={i18next.t('deforestationMonitoringData-deter')}
        monitoringDataList={deter || []}
      />
    </ListGridContainer>
  );
};
